import { Injectable } from '@angular/core';
import { AsyncSubject, Observable, distinctUntilChanged, map, noop } from 'rxjs';

import { MeasGroup, MeasGroupQueryParams, MeasGroupWithRevision, recursiveQueryWithRevision } from '../models/meas-group.model';
import { DistinctSubject } from '../models/utility.model';
import { AuthUsecase } from '../usecases/auth.usecase';
import { MeasGroupGateway } from '../usecases/meas-group.gateway';
import { MeasGroupUsecase } from '../usecases/meas-group.usecase';

@Injectable()
export class MeasGroupInteractor extends MeasGroupUsecase {
  get measGroups$(): Observable<MeasGroupWithRevision | undefined> {
    return this._measGroups;
  }

  private readonly _measGroups = new DistinctSubject<MeasGroupWithRevision | undefined>(undefined);
  constructor(
    private _authUsecase: AuthUsecase,
    private _measGroupGateway: MeasGroupGateway,
  ) {
    super();

    this._authUsecase.authState$
      .pipe(
        map(({ status }) => status === 'signedIn'),
        distinctUntilChanged(),
      )
      .subscribe(signedIn => (signedIn ? noop : this.onSignOut()));
  }

  listMeasGroups(): Observable<never> {
    const result = new AsyncSubject<never>();
    recursiveQueryWithRevision<MeasGroupQueryParams, MeasGroup>(params => this._measGroupGateway.listMeasGroups(params), {}).subscribe({
      next: measGroups => this._measGroups.next(measGroups),
      error: result.error.bind(result),
      complete: result.complete.bind(result),
    });
    return result.asObservable();
  }

  private onSignOut(): void {
    this._measGroups.next(undefined);
  }
}
